import Form from '@rjsf/material-ui';
import { useDispatch } from 'react-redux';
import { Dimmer, Loader } from 'semantic-ui-react';
import { addClient } from '../../redux/actions/clients';
import validator from '@rjsf/validator-ajv8';
import useClientForm from '../../hooks/useClientForm';

const AddClient = () => {
  const { clientFormSchema, isLoading } = useClientForm();

  const dispatch = useDispatch();
  const handlerSubmit = ({ formData }: any) => {
    dispatch(addClient(formData));
  };

  return (
    <div style={{ maxWidth: 500 }}>
      {isLoading ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : (
        <Form
          schema={clientFormSchema}
          validator={validator}
          onSubmit={handlerSubmit}
        />
      )}
    </div>
  );
};

export default AddClient;
